import type { OfficialTypeNameLookup } from '../types'

interface TeamOfficialTypeEntry {
  id: number | string
  name?: string | null
  name_full?: string | null
}

/**
 * Builds a lookup from a team-official type id to the role's display name,
 * e.g. 1 → "Manager", from one sport's role list (`useTeamOfficialTypes`).
 *
 * Returns `undefined` for an unknown id — the caller renders no role rather
 * than a raw id.
 */
export const buildOfficialTypeNameLookup = (
  officialTypes: TeamOfficialTypeEntry[] | null | undefined
): OfficialTypeNameLookup => {
  const names = new Map<string, string>()

  for (const type of officialTypes ?? []) {
    const name = type.name_full || type.name
    if (name) {
      names.set(String(type.id), name)
    }
  }

  return (teamOfficialTypeId) => names.get(String(teamOfficialTypeId))
}
